import Text from 'components/base/Text';
import copy from 'copy-to-clipboard';

export const copyToClipboard = ({
  value,
  toggleSnackBar,
  snackbarText = 'Text was copied to clipboard'
}) => {
  copy(value);
  if (toggleSnackBar && typeof toggleSnackBar == 'function') {
    toggleSnackBar({
      message: (
        <Text size='large' color='white'>
          {snackbarText}
        </Text>
      ),
      variant: 'success'
    });
  }
};
